<template>
  <div class="form-group mt-3 range-input" ref="container">
    <div class="set-value" ref="rangeValue" :style="{
      left: `${fillPercentage}%`,
      'margin-left': `-${marginLeftAdjustment}px`
    }">{{value}}</div>
    <span class="fill" :style="{
      width: `${fillPercentage}%`
    }"></span>
    <input
      ref="range"
      type="range"
      class="form-control-range"
      :value="value"
      @input="handleChange"
      v-on="$listeners"
      v-bind="$attrs"
    />
    <div class="markers d-flex align-items-center justify-content-between">
      <div v-for="(marker, key) in markers" :key="key">{{marker}}</div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    event: "update"
  },
  props: {
    value: {
      type: [String, Number],
      default: 0
    },

    markers: {
      type: Array
    }
  },

  computed: {
    marginLeftAdjustment() {
      let returnValue = 0;
      if (this.initialized) {
        try {
          const initialAdjustment = this.$refs.rangeValue.clientWidth * 0.8;
          let percentage = (this.value / +this.$refs.range.max + 0.15)
          returnValue = initialAdjustment * percentage
        } catch (e) {
          returnValue = 0;
        }
      }
      return returnValue;
    },

    fillPercentage() {
      let returnValue = 0;
      if (this.initialized) {
        try {
          returnValue = (this.value / +this.$refs.range.max) * 100;
        } catch (e) {
          returnValue = 0;
        }
      }
      return returnValue;
    }
  },

  data() {
    return {
      initialized: false
    };
  },

  mounted() {
    this.initialized = true;
  },

  methods: {
    handleChange($event) {
      this.$emit("update", $event.target.value);
    }
  }
};
</script>
